import { FolderOpen, MagnifyingGlass } from "@phosphor-icons/react";
import React, { useState } from "react";

export default function ReferenceLog() {
  const [refrence] = useState([]);

  if (refrence.length === 0) {
    return (
      <div className="w-full h-full pt-10">
        <div className="w-full h-[50%] ">
          <nav className="border-1 flex justify-between w-full p-4 border border-gray-400 rounded-tl-md rounded-tr-md ">
            <p className="self-start">Reference tree</p>
    
          </nav>
          <span className="flex justify-center items-center  flex-col gap-2 border border-t-0 border-gray-400 h-full">
            <FolderOpen size={72} />
            <p>No reference user found</p>
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div className="w-full h-full pt-10">
        <div className="w-full h-fit ">
          <nav className="border-1 flex justify-between w-full p-4 border border-gray-400 rounded-tl-md rounded-tr-md ">
            <p>All Signals</p>
            <div className="relative">
              <input
                type="text"
                placeholder="Search ID or Title"
                className="h-8 p-2 text-black pr-[2.2rem] rounded-tr-full rounded-br-full "
              />
              <button className="bg-green-400 rounded absolute top-0 right-0">
                <MagnifyingGlass size={32} />
              </button>
            </div>
          </nav>
          <ul>
            {refrence.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}
